import React from 'react';
import UndsenHurunguTovchooTS from './undsenHurunguTovchooTS';

const PageList = () => <UndsenHurunguTovchooTS />;

export default PageList;
